import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TranslateIcon from '@material-ui/icons/Translate';
import OfflineDb from '../../db'
import { apiServices } from '../../services/apiServices';
import { useTranslation, initReactI18next } from 'react-i18next';
import { useGlobalSpinnerActionsContext } from '../../context/GlobalSpinnerContext'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function LanguageSelect() {
  const classes = useStyles();
  const [value, setValue] = React.useState('my');
  const [resources, setResources] = React.useState({});
  const {t, i18n} = useTranslation();
  const setGlobalSpinner = useGlobalSpinnerActionsContext()
  /*useEffect(() => {
    //get use details from localdb
    OfflineDb.getDataFromPouchDB('translationResource')
    .then(translationResource => {
      if(translationResource.data != undefined) {
        setResources(translationResource.data)
      } else {
        setGlobalSpinner(true)
        apiServices.getAPI('dataStore/translations/translations').then(res=>{
          OfflineDb.setDataIntoPouchDB('translationResource',res.data)      
          setResources(res.data)
          setGlobalSpinner(false)
          localStorage.setItem("translations",JSON.stringify(res.data))      
        }).catch(error => {
          setGlobalSpinner(false)  
        })
      }
    })    

    OfflineDb.getDataFromPouchDB('languageSelected')
      .then(languageSelected => {
        if (languageSelected.data != undefined) {
          setValue(languageSelected.data)
        }

      })
      
  }, [])*/

  useEffect(() => {
        let data = {"en": {
          "translation": {
            "User Name": "User Name",
            "Password": "Password",
            "Login": "Login",
            "Reset": "Reset",
            "Forgot Password?":"Forgot Password?",
            "Sign In":"Sign In",
            "Required":"Required",
            "Incorrect expression added as input":"Incorrect expression added as input",
            "Incorrect expression '< or >' added as input":"Incorrect expression '< or >' added as input",
            "Incorrect password pattern":"Incorrect password pattern",
            "Please enter username":"Please enter username",
            "Cancel":"Cancel",
            "Submit":"Submit"
          }
        },"my": {
          "translation": {
            "User Name": "အသုံးပြုသူအမည်",
            "Password": "စကားဝှက်",
            "Login": "ဝင်မည်",
            "Reset": "ပြန်စမည်",
            "Forgot Password?":"စကားဝှက်မေ့နေပါသလား?",
            "Sign In":"အသုံးပြုသူဝင်ရောက်ခြင်း",
            "Login failed":"လော့ဂ်အင်မအောင်မြင်ပါ",
            "Unauthorized":"ခွင့်မပြု",
            "Required":"လိုအပ်သည်",
            "Incorrect expression added as input":"Incorrect expression added as input2",
            "Incorrect expression '< or >' added as input":"Incorrect expression '< or >' added as input",
            "Incorrect password pattern":"စကားဝှက်မှားနေသည်",
            "Please enter username":"အသုံးပြုသူအမည်ထည့်ပါ",
            "Cancel":"မလုပ်ပါ",
            "Submit":"တင်သွင်းသည်",
            "Close":"ပိတ်မည်",
            "Fail":"မအောင်မြင်",
            "User does not exist":"အသုံးပြုသူမရှိပါ။"
          }
        }}
        setResources(data)
  },[])

  useEffect(() => {
    if(resources != null && !localStorage.getItem("translations")){
      handleChange({"target":{"value":value}})
    }
  },[resources])

  const handleChange = (event) => {
    setValue(event.target.value);
    let lngValue = event.target.value
    if (lngValue) {
        OfflineDb.setDataIntoPouchDB('languageSelected', lngValue)
        localStorage.setItem('locale', lngValue)
        i18n
          .use(initReactI18next) // passes i18n down to react-i18next
          .init({
            resources,
            fallbackLng: 'en',
            lng: lngValue, //localStorage.getItem('locale') ? localStorage.getItem('locale'): 'en',          
            keySeparator: false, // we do not use keys in form messages.welcome
  
            interpolation: {
              escapeValue: false // react already safes from xss
            },
            react: {
              useSuspense: false,
              wait: false,
            },
          });
        }
  };

  return (
    <div>
      <FormControl className={classes.formControl}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          onChange={handleChange}
        >
          <MenuItem value={"my"}>မြန်မာ</MenuItem>
          <MenuItem value={"en"}>English</MenuItem>
          
        </Select>
      </FormControl>
      
    </div>
  );
}